import { css } from '@emotion/react'
import { Theme } from '@mui/material'

export const technicalReportPopupContainer = ({ theme }: { theme: Theme }) => css`
  display: flex;
  flex-direction: column;
  margin: 16px 0;
  width: 100%;
  max-height: 280px;
  overflow-y: auto;
  font-size: 14px;
  line-height: 1.5;

  .report-row {
    border-bottom: 1px solid ${theme.palette.grey[100]};
    display: flex;
    justify-content: space-between;

    &:last-child {
      border-bottom: none;
    }
  }
  .report-property {
    font-weight: bold;
    padding: 8px 0;
    width: 180px;
    flex-shrink: 0;
  }
  .report-value {
    flex-grow: 1;
    padding: 8px 0;
    a {
      color: ${theme.palette.blue.main};
      text-decoration: none;
      &:hover {
        text-decoration: underline;
      }
    }
  }
`

export const reportTabs = ({ theme }: { theme: Theme }) => css`
  display: flex;

  .report-tab {
    font-size: 12px;
    line-height: 1.5;
    padding: 4px 8px;
    border-radius: 0;
    font-weight: 500;
    color: ${theme.palette.uintel.main};
    background-color: ${theme.palette.white.main};
    box-shadow: none;
    border: 1px solid ${theme.palette.uintel.main};
    border-right: none;

    &:first-of-type {
      border-top-left-radius: 4px;
      border-bottom-left-radius: 4px;
    }
    &:last-of-type {
      border-top-right-radius: 4px;
      border-bottom-right-radius: 4px;
      border-right: 1px solid ${theme.palette.uintel.main};
    }

    &:hover {
      background-color: ${theme.palette.uintel.main}10;
    }
    &.active {
      background-color: ${theme.palette.uintel.main};
      color: ${theme.palette.white.main};
      font-weight: 600;
    }
  }
`
